/* eslint-disable @atlassian/relay/unused-fields -- fields are consumed by callers via the return value */
import { graphql, fetchQuery, type Environment } from 'react-relay';

import type { tenantVizGetActivationIdsQuery } from './__generated__/tenantVizGetActivationIdsQuery.graphql';

/**
 * Resolves all activation IDs for a given cloud ID via Relay.
 * Used by chart creation flows to derive workspaceId from cloudId.
 */
export async function getActivationIdsByCloudId(
	environment: Environment,
	cloudId: string,
): Promise<tenantVizGetActivationIdsQuery['response']> {
	const data = await fetchQuery<tenantVizGetActivationIdsQuery>(
		environment,
		graphql`
			query tenantVizGetActivationIdsQuery($cloudId: ID!) {
				tenantContexts(cloudIds: [$cloudId]) {
					activationIds {
						product
						active
					}
				}
			}
		`,
		{ cloudId },
	).toPromise();

	if (!data) {
		throw new Error('Failed to fetch activation IDs');
	}

	return data;
}
